import { SecondaryNavigationBar } from '@opendoor/mosaic';

import { WEB_URL } from '../../utils/constants';

interface WorkOrderNavigationBarProps {
  workOrderId: string;
}

const WorkOrderNavigationBar = ({ workOrderId }: WorkOrderNavigationBarProps) => {
  const links = [
    {
      title: 'General',
      href: WEB_URL + '/vendor/work-orders/' + workOrderId + '/general',
    },
    {
      title: 'Line Items',
      href: WEB_URL + '/vendor/work-orders/' + workOrderId + '/line-items',
    },
    {
      title: 'Photos',
      href: WEB_URL + '/vendor/work-orders/' + workOrderId + '/photos',
    },
    {
      title: 'Progress',
      href: '#',
      isActive: true,
      isHeading: true, // ignored
    },
  ];

  return (
    <div className="ml--4 mt--3">
      <SecondaryNavigationBar links={links} isPanelConstrained={true} />
    </div>
  );
};

export default WorkOrderNavigationBar;
